export default __webpack_public_path__ + "static/media/curtain.89cae8bf.png";